module.exports = __webpack_public_path__ + "static/toast-action-dont-06b7ec81bd1ad8b093886443d1d9523e.png";